module.exports = __webpack_public_path__ + "static/media/logo.082c0161.png";